import {PageCESU, PageSAP} from "./pagesEBU"

/**
 * Enum associant à chaque item d'un menu la liste
 * des autres pages pour lesquelles il doit être activé
 *
 * A utiliser avec la methode getActivatingPages
 *
 * Exemple :
 * Lorsque la page actuelle est CESU_CONVERSION_AMOUNT,
 * l'item du menu correspondant à la page CESU_CONVERSION_CHOICE
 * doit être activé (souvent pour les actions en plusieurs étapes)
 */
export const ACTIVATING_PAGES = {
    [PageCESU.CESU_CONVERSION_CHOICE]: [
        PageCESU.CESU_CONVERSION_AMOUNT,
        PageCESU.CESU_CONVERSION_CONFIRMATION,
        PageCESU.CESU_CONVERSION_DELIVERY,
    ],
    [PageCESU.MILLESIME_TRADE_CHOICE]: [
        PageCESU.MILLESIME_TRADE_CONFIRMATION,
        PageCESU.MILLESIME_TRADE_DELIVERY,
        PageCESU.MILLESIME_TRADE_PAYMENT,
    ],
    [PageCESU.ORDER_SESSION_LIST]: [
        PageCESU.ORDER_INFORMATION,
        PageCESU.ORDER_CONTENT,
        PageCESU.ORDER_CONFIRMATION,
        PageCESU.ORDER_DELIVERY,
        PageCESU.ORDER_PAYMENT,
        PageCESU.ORDER_PROFILE,
    ],
    [PageCESU.PAYMENT_CHOICE]: [
        PageCESU.ACCOUNT_PAYMENT_AMOUNT_OVERVIEW,
        PageCESU.ACCOUNT_PAYMENT_AMOUNT,
        PageCESU.ACCOUNT_PAYMENT_CESU_DECLARATION,
        PageCESU.ACCOUNT_PAYMENT_CESU_IDENTIFICATION,
        PageCESU.ACCOUNT_PAYMENT_CHOICE,
        PageCESU.ACCOUNT_PAYMENT_CONFIRMATION,
        PageCESU.ACCOUNT_PAYMENT_ORGANIZATION,
        PageCESU.ACCOUNT_PAYMENT_PAJE_DECLARATION,
        PageCESU.ACCOUNT_PAYMENT_PAJE_IDENTIFICATION,
        PageCESU.CHECK_PAYMENT_AMOUNT,
        PageCESU.CHECK_PAYMENT_CHOICE,
        PageCESU.CHECK_PAYMENT_CONFIRMATION,
    ],
    [PageSAP.CREATION_DEMANDE_CHOIX_DISPOSITIF]: [
        PageSAP.CREATION_DEMANDE_CHOIX_DISPOSITIF,
        PageSAP.CREATION_DEMANDE_CHOIX_PRESTATION,
        PageSAP.CREATION_DEMANDE_CONFIRMATION,
        PageSAP.CREATION_DEMANDE_DETAILS_PRESTATION,
        PageSAP.CREATION_DEMANDE_INFORMATIONS_COMPLEMENTAIRES,
        PageSAP.CREATION_DEMANDE_INFORMATIONS_PAIEMENT,
        PageSAP.CREATION_DEMANDE_NOS_PRESTATIONS,
        PageSAP.CREATION_DEMANDE_QUESTIONS_ATTRIBUTION,
    ],
    [PageSAP.COMMANDE_SUIVI]: [PageSAP.VISUALISATION_MODIFICATION_DEMANDE],
    [PageSAP.PROFILE]: [PageSAP.PROFILE_MAIN_INFORMATIONS, PageSAP.MY_PROFILE_MAIN_INFORMATIONS],
}
